var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  stroke: "#374151",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M175 87.078a6 6 0 0 0-6-6h-56.831a6 6 0 0 0-6 6v35.792a6 6 0 0 0 6 6h37.45l9.547 8.839c1.28 1.185 3.358.277 3.358-1.468v-7.371H169a6 6 0 0 0 6-6z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#374151",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M75 67a8 8 0 0 1 8-8h64.519a8 8 0 0 1 8 8v40.364a8 8 0 0 1-8 8h-42.827l-11.733 10.95c-1.279 1.193-3.365.287-3.365-1.462v-9.488H83a8 8 0 0 1-8-8z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 96.137,
  cy: 87.182,
  r: 6.039,
  fill: "#9CA3AF"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 115.259,
  cy: 87.182,
  r: 6.039,
  fill: "#9CA3AF"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 134.383,
  cy: 87.182,
  r: 6.039,
  fill: "#9CA3AF"
})));
export default SvgMessage;